export default __webpack_public_path__ + "static/media/Q0006.95fd1d0f.png";